import { ErrorsList } from '../../types/errors';

export const combineValidators = async (
  validators: Promise<ErrorsList>[]
) => (await Promise.all(validators)).flat();
